// @flow
import * as React from 'react';
import {Skeleton, Stack} from "@mui/material";
import {useState} from "react";
import {CallCard} from "./call-card";
import { CallHistoryItemsQuery } from '../../../../../shared';
import { useClient } from '../../../hooks/client-context';
import _ from 'lodash';
import { CallAiAnalysisDrawer } from './call-ai-analysis-drawer';

type Call = CallHistoryItemsQuery['callHistoryItems']['data'][0]

type Props = {
  calls?: Call[];
  loading: boolean;
  onChange: () => void;
};

export const CallsList = ({calls, loading, onChange}: Props) => {
  const client = useClient();
  const [analisysOpen, setAnalisysOpen] = useState(false);
  // Track the selected call by id and derive the live call from `calls` so the drawer
  // reflects refetched data (e.g. after a QA edit) without a manual refresh — instead of
  // freezing a stale snapshot.
  const [selectedCallId, setSelectedCallId] = useState<string>()
  const call = calls?.find(c => c.id === selectedCallId);

  if (loading && !calls?.length) {
    return <Loading />
  }

  return (<>
    <CallAiAnalysisDrawer call={call} open={analisysOpen} onClose={() => {
      setSelectedCallId(undefined)
      setAnalisysOpen(false)
    }} />


    <Stack gap={2}>
      {_.orderBy(calls, 'createdAt', 'desc')?.map((c, index) => (
        <CallCard call={c} key={c.id}
                  client={client}
                  onChange={onChange}
                  onClick={() => {
                    setSelectedCallId(c.id)
                    setAnalisysOpen(true)
                  }} />
      ))}
    </Stack>
  </>);
};

const Loading = () => (
  <Stack gap={1}>
    {Array(3).fill(0).map((_, i) => (
      <Skeleton variant={'rounded'} height={70} width={'100%'} />
    ))}
  </Stack>
)
